import React, { useCallback, useContext } from 'react'
import {
  Box,
  useResponsiveWrapperContext,
  ImageLoader,
} from '@usap/uicomponents'

import { LocalContext } from '../../../../../../helpers/useLocalContext'
import generateProductUrl from '../Details/hooks/generateProductUrl'
import PageTypeIdentifier from '../../../../../../helpers/PageTypeIdentifier'
import useWmoEnabled from '../../../../../../hooks/useWmoEnabled'
import ImageWmo from './ImageWmo'

const Image = props => {
  const { data, trackSelectItem } = props
  const { isDesktop } = useResponsiveWrapperContext()
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const isWmoEnabled = useWmoEnabled()

  const productUrl = generateProductUrl(data)
  const onClick = useCallback(() => {
    trackSelectItem()
    PageTypeIdentifier.pdp()
  }, [data])

  if (isWmoEnabled) {
    return (
      <ImageWmo data={data} productUrl={productUrl} onClick={onClick} />
    )
  }

  return (
    <Box
      width={isDesktop ? '30%' : '40%'}
      pad="small"
      alignSelf={isDesktop ? 'center' : 'start'}
    >
      <Link to={productUrl} onClick={onClick} skip>
        <Box height="125px" width="125px">
          <ImageLoader
            key={data.product.image.url}
            width="100%"
            height="100%"
            src={data.product.image.url}
            fit="contain"
            alt={`${data.product.sku}-${data.product.title}`}
            cloudinaryParams="h_125,w_125"
            fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
          />
        </Box>
      </Link>
    </Box>
  )
}

export default Image
